import { post, get } from './requests'
import { getToken } from '_/utils/token'

export const createTradesmanSequence = (key, serviceOrderId, payload) =>
  post(
    ['serviceorders', serviceOrderId, 'sequences'],
    { ...(key ? { key } : getToken()), transformPayload: true },
    payload
  )

export const getTradesmanSequence = (key, serviceOrderId) =>
  get(['serviceorders', serviceOrderId, 'sequences'], key ? { key } : getToken())

export const acceptByTradesmanService = (key, serviceOrderId, payload) =>
  post(
    ['serviceorders', serviceOrderId, 'accept-serviceorder-for-provider'],
    { ...(key ? { key } : getToken()), transformPayload: true },
    payload
  )

export const acceptIBByTradesmanService = (key, serviceOrderId, payload) =>
  post(
    ['serviceorders', serviceOrderId, 'accept-inner-budget-for-provider'],
    { ...(key ? { key } : getToken()), transformPayload: true },
    payload
  )
